// src/pages/Cloud/components/fsc/useFscProjectBootstrap.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchFSCAssessments, fetchFSCControlTree } from '../../../../store/slices/fscComplianceSlice';
import { fetchComplianceSummary } from '../../../../store/slices/complianceSlice';

/** projectUuid、cloud、cloudScope 存在時載入 FSC 控制項樹與 assessments；摘要由外層頁面統一查詢。 */
export function useFscProjectBootstrap(projectUuid, cloud, cloudScope) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!projectUuid || !cloud) return;
    const params = { project_uuid: projectUuid, cloud, cloud_scope: cloudScope };
    dispatch(fetchFSCControlTree(params));
    dispatch(fetchFSCAssessments(params));
  }, [dispatch, projectUuid, cloud, cloudScope]);
}

/** 需要 await 時使用；可選擇是否 unwrap 以保留既有錯誤流程 */
export async function refreshFscProjectData(
  dispatch,
  projectUuid,
  cloud,
  { unwrap = false, platform, cloudScope } = {}
) {
  if (!projectUuid || !cloud) return;

  const params = { project_uuid: projectUuid, cloud, cloud_scope: cloudScope };
  const treeAction = dispatch(fetchFSCControlTree(params));
  const assessmentsAction = dispatch(fetchFSCAssessments(params));
  const summaryAction = platform ? dispatch(fetchComplianceSummary({ platform })) : null;

  if (unwrap) {
    const tasks = [treeAction.unwrap(), assessmentsAction.unwrap()];
    if (summaryAction) tasks.push(summaryAction.unwrap());
    await Promise.all(tasks);
    return;
  }

  const idle = [treeAction, assessmentsAction];
  if (summaryAction) idle.push(summaryAction);
  await Promise.all(idle);
}
